/**
 * @generated SignedSource<<7f6556eba348c4e1df94ffe1af75e7a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FallbackCell$data = {
  readonly id: string;
  readonly renderedFieldHtml: string | null | undefined;
  readonly type: string;
  readonly " $fragmentType": "FallbackCell";
};
export type FallbackCell$key = {
  readonly " $data"?: FallbackCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FallbackCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FallbackCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ],
  "type": "JiraFallbackField"
};

(node as any).hash = "5a44333782fe000d835b0ea393cc6a88";

export default node;
